import apply from './helpers/apply';
import standard from './standard';
import {
  addForToLabel,
  labelToPlaceholder,
  labelToSelectOption,
  textNodeToPlaceholder,
  inputImageToButton,
  normalizeHiddenFields,
  clearForm,
  applyAttributes,
} from './factories';


const filters = [
  addForToLabel,
  labelToPlaceholder,
  labelToSelectOption,
  textNodeToPlaceholder,
  inputImageToButton,
  normalizeHiddenFields,
  clearForm,
  applyAttributes,
];

const format = html => {
  const standardResult = standard(html);

  if (!standardResult) {
    return '';
  }

  return apply(filters, standardResult);
};

export default format;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/format.js
 **/